<template>
    <footer class="footer-section">
        <div class="container">
            <div class="footer-content pt-5 pb-5">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 mb-5">
                        <div class="footer-widget">
                            <div class="footer-logo">
                                <a href="/"><img :src="getImagePath(localSettings?.logo)" class="img-fluid" alt="Logo" title="Logo" width="200" height="70"></a>
                            </div>
                            <div class="footer-text">
                                <p class="mb-1">Discover top businesses and services with BizRAR! Our directory makes finding trusted professionals and quality products effortless. Start now!</p>
                            </div>
                            <div class="footer-text">
                                <p style="font-weight: 600;">Email: {{localSettings?.email}}</p>
                            </div>
                           <div class="footer-social-icon mm-10">
    <a v-if="localSettings?.facebook_link" 
        aria-label="Facebook"
        :href="localSettings?.facebook_link" class="social-btn facebook">
        <i class="fab fa-facebook-f text-white"></i>
    </a>
    <a v-if="localSettings?.phone" 
        aria-label="Whatsapp"
        :href="`https://wa.me/${formatPhone(localSettings?.phone)}`" target="_blank" class="social-btn whatsapp">
        <i class="fab fa-whatsapp text-white"></i>
    </a>
    <a v-if="localSettings?.twitter_link" 
        aria-label="X"
        :href="localSettings?.twitter_link" class="social-btn twitter">
        <i class="bi bi-twitter-x text-white"></i>
    </a>
    <a v-if="localSettings?.youtube_link" 
        aria-label="Youtube"
        :href="localSettings?.youtube_link" class="social-btn youtube">
        <i class="fab fa-youtube text-white"></i>
    </a>
    <a v-if="localSettings?.instagram_link" 
        aria-label="Instagram"
        :href="localSettings?.instagram_link" class="social-btn instagram">
        <i class="fab fa-instagram text-white"></i>
    </a>
</div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-6 col-6 mb-3">
                        <div class="footer-widget">
                            <div class="footer-widget-heading">
                                <h3>About</h3>
                            </div>
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><router-link to="/help-center">Help center</router-link></li>
                                <li><router-link to="/about-us">About us</router-link></li>
                                <li><router-link to="/contact-us">Contact us</router-link></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-6 col-6 mb-3">
                        <div class="footer-widget">
                            <div class="footer-widget-heading">
                                <h3>Discover</h3>
                            </div>
                            <ul>
                                <li><router-link to="/company-info">Company </router-link></li>
                                <li><router-link to="/investor-info">Investors</router-link></li>
                                <li><router-link to="/blogs">Blogs</router-link></li>
                                <li><router-link to="/faqs">FAQ's</router-link></li>
                                <li><a href="/register">Start Writing</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-6 col-6 mb-3">
                        <div class="footer-widget">
                            <div class="footer-widget-heading">
                                <h3>Legal</h3>
                            </div>
                            <ul>
                                <li><router-link to="/terms-and-conditions">Terms and Condition </router-link></li>
                                <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
                                <li><router-link to="/cookies-policy">Cookie Policy</router-link></li>
                                <li><router-link to="/referral-program">Referral Program</router-link></li>
                                <li v-for="page in morePages">
                                    <router-link style="text-transform: none;"
                                        :to="{ name: 'more_pages', params: {slug: page.slug}}">
                                        {{page.title}}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-6 col-6 mb-5">
                        <div class="footer-widget">
                            <div class="business-box">
                                <h4>For Business</h4>
<!--                                <router-link to="/get-started"><p>Get Started</p></router-link>-->
                                <router-link to="/pricing"><p>Add Business</p></router-link>
                                <a href="/login"><p>Guest Posting</p></a>
                                <router-link to="/investor-info"><p>Retailers</p></router-link>
                                <router-link to="/company-info"><p>Company</p></router-link>
                                <router-link to="/author-explore"><p>Author</p></router-link>
                            </div>
                        </div>
                    </div>
                    <div v-if="cartItems && cartItems.count > 0" class="floating-cart-icon" @click="openCart">
                        <i class="fas fa-shopping-cart" style="font-size: 18px;color: white;"></i>
                        <span class="cart-item-count">{{ cartItems.count }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright-area">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12 col-lg-12 text-center text-lg-left">
                        <div class="copyright-text">
                            <p>Copyright © {{ year }} BizRAR  are registered trademarks of <a href="https://codingcrust.com/">Coding Crust</a>, LLC. All Rights Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    data() {
        return {
            localSettings: null,
        }
    },
    computed: {
        ...mapState('business', ['cartItems']),
        ...mapState('home', ['settings', 'morePages', 'loadingMorePages']),
        year() {
            return new Date().getFullYear();
        }
    },

    watch: {
        settings: {
            handler(newValue) {
                this.localSettings = newValue;
            },
            immediate: true
        }
    },

    methods: {
        ...mapActions('home', ['fetchMorePages']),
        openCart() {
            this.$router.push({
                path: '/cart',  // Ensure you have this route defined
            });
        },
        getImagePath(relativePath) {
            // Check if the path is already an absolute URL
            const isAbsolute = /^(http|https):\/\//i.test(relativePath);

            // Return absolute URL if already full, otherwise build it
            return isAbsolute
                ? relativePath
                : `${window.location.origin}/${relativePath?.replace(/^\/+/, "")}`;
        },
        formatPhone(phone) {
            if (!phone) return ''; 
            const cleaned = phone?.replace(/\D/g, ''); // Remove everything except digits
            // Ensure it starts with country code (like 92 for Pakistan)
            return cleaned?.startsWith('92') ? cleaned : `92${cleaned?.replace(/^0+/, '')}`;
        },
    },
    mounted() {
        this.fetchMorePages();
    }
};
</script>

<style scoped>
.footer-social-icon {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    align-items: center;
}

.footer-social-icon .social-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    text-decoration: none;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.footer-social-icon .social-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.25);
    color: #fff;
}

.footer-social-icon .social-btn.facebook  { background: #1877f2; }
.footer-social-icon .social-btn.whatsapp  { background: #25d366; }
.footer-social-icon .social-btn.twitter   { background: #000; }
.footer-social-icon .social-btn.youtube   { background: #ff0000; }
.footer-social-icon .social-btn.instagram { background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888); }
.floating-cart-icon {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #ff5722;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    cursor: pointer;
    font-size: 24px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 9999;
}

.cart-item-count {
    position: absolute;
    top: -6px;
    right: 0px;
    background-color: #fff;
    color: #ff5722;
    border-radius: 50%;
    padding: 2px 6px;
    font-size: 12px;
    font-weight: bold;
}
.whatsap-bg{
    background: #339952;
    color:white !important;
}
</style>
